import { CountryCode } from '@rover/constants/src/geography/geo.constants';
import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import useIsBHUserShim from '@rover/shared/js/hooks/useIsBHUserShim';

import { ELIGIBLE_COUNTRIES } from '../../../bright-horizons-checkout/components/BHHowToPay/constants';

import { useRevampProfileContext } from './useRevampProfileContext';

type RevampCtaData = {
  sitterData: EnhancedPersonSitterProfile;
  serviceType: string | undefined;
  setServiceType: (serviceType: string) => void;
  selectedService: EnhancedPersonSitterProfile['services'][number] | undefined;
  serviceDisplayName: string | undefined;
  cancellationPolicy: string | undefined;
  isBrightHorizonsUser: boolean;
  isNonEligibleCountry: boolean;
  isSelectedServiceUnapproved: boolean;
  isContactUnavailable: boolean;
};

export const useRevampCta = (): RevampCtaData => {
  const { sitterData, serviceType, setServiceType } = useRevampProfileContext();
  const { user } = useCurrentUserShim();
  const countryCode = user?.address?.countryCode || CountryCode.US;
  const isBrightHorizonsUser = useIsBHUserShim();
  const isNonEligibleCountry = !!countryCode && !ELIGIBLE_COUNTRIES.includes(countryCode);

  const selectedService = sitterData.services.find((s) => s.slug === serviceType);

  const serviceDisplayName = selectedService?.displayName;
  const cancellationPolicy = selectedService?.meta?.cancellationPolicy;

  const isSelectedServiceUnapproved = !!selectedService && !selectedService.isApproved;
  // A stale/invalid service_type resolves to no service, so contactUrl carries a slug
  // that would fail. Treat any set-but-unapproved (or unmatched) service as uncontactable.
  const isContactUnavailable = !!serviceType && !selectedService?.isApproved;

  return {
    sitterData,
    serviceType,
    setServiceType,
    selectedService,
    serviceDisplayName,
    cancellationPolicy,
    isBrightHorizonsUser,
    isNonEligibleCountry,
    isSelectedServiceUnapproved,
    isContactUnavailable,
  };
};
